import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_WEB_API_URL;

export const upsertUserAnnouncement = async (
	announcementId,
	acknowledged
) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/announcement/`, retry: true });

		const body = {
			acknowledged
		};

		const requestUrl = `${announcementId}`;

		return await instance
			.put(requestUrl, body)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		console.error(error);
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getUserAnnouncements = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/announcement/`, retry: true });

		const requestUrl = ``;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
